import { backendApi } from "@/services/backend/api";
import { Defaults, Key } from "@/services/backend/rlt/defaults/types/defaults";

const defaultsApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    showRLTDefaults: build.query<Defaults, ShowRequest>({
      query: (request) => ({
        url: `/rlt/defaults`,
        method: "GET",
        params: request,
      }),
      providesTags: (_r, _e, request) => [
        { type: "RltDefaults", id: request.key },
      ],
    }),
    putRLTDefaults: build.mutation<Defaults, PutRequest>({
      query: (request) => ({
        url: `/rlt/defaults`,
        method: "PUT",
        body: request,
      }),
      invalidatesTags: (_r, _e, request) => [
        { type: "RltDefaults", id: request.key },
      ],
    }),
  }),
});

export const {
  useShowRLTDefaultsQuery: useRltDefaultsShowQuery,
  usePutRLTDefaultsMutation: useRltDefaultsPutMutation,
} = defaultsApi;

export interface ShowRequest {
  key: Key;
}

export type PutRequest = Defaults;
